import React from 'react';

const CreditTab = () => {
  return (
    <div>
      
    </div>
  );
};

CreditTab.propTypes = {};

export default CreditTab;
